import Link from 'react-router-dom'
import React from 'react';

function RDVButtonComponent (){
 return (
    <div id="rdv-section">
      <a href="https://www.doctolib.fr/osteopathe/clichy/thomas-tailleur" className="btn btn-primary btn-sm" target="_blank">Prendre rendez-vous en ligne</a>
    </div>
 )
}

export default RDVButtonComponent;
